import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { FaStar, FaShoppingCart, FaHeart, FaUser, FaHome, FaPhone, FaEnvelope } from 'react-icons/fa';
import ProductCard from '../components/ProductCard';

const products = [
  {
    id: 1,
    name: 'Pistazien-Trüffelbox',
    price: 29.90,
    rating: 5,
    shortDesc: 'Feine Trüffel mit Pistazienherz',
    description: 'Unsere Pistazien-Trüffel sind eine Hommage an die italienische Confiserie-Kunst. Jede Trüffel wird von Hand gefertigt und mit feinster Pistaziencreme gefüllt. Die dunkle Kakaoumhüllung harmoniert perfekt mit dem nussigen Aroma. Die Box enthält zwölf handverlesene Trüffel, verziert mit gehackten Pistazien. Perfekt als Geschenk oder für den eigenen Genuss. Die Trüffel werden täglich frisch in unserer Manufaktur in Ettlingen hergestellt.',
    image: '/images/1.jpg',
    isNew: true,
    detailedInfo: 'Die Pistazien-Trüffel von Novurem werden ausschließlich mit Pistazien aus Sizilien hergestellt. Unsere Chocolatiers verfeinern die Trüffel mit einem Hauch von Meersalz und echter Bourbon-Vanille. Die Herstellung dauert 48 Stunden und erfolgt in kleinen Chargen. Jede Trüffel ist ein Unikat und wird nach traditionellem Rezept gefertigt.'
  },
  {
    id: 2,
    name: 'Vanille-Macarons',
    price: 24.50,
    rating: 4,
    shortDesc: 'Luftige Macarons mit Bourbonvanille',
    description: 'Unsere Vanille-Macarons sind ein Klassiker der französischen Patisserie. Die zarten Mandelmakronen werden mit einer cremigen Bourbonvanille-Füllung kombiniert. Die Textur ist außen knusprig und innen herrlich weich. Jede Box enthält zehn handgefertigte Macarons. Die Vanille stammt aus Madagaskar und verleiht den Macarons ein unvergleichliches Aroma.',
    image: '/images/2.jpg',
    isNew: false,
    detailedInfo: 'Für unsere Vanille-Macarons verwenden wir ausschließlich echtes Bourbonvanille-Mark aus Madagaskar. Die Mandeln werden täglich frisch gemahlen und mit Bio-Eiweiß zu einer perfekten Konsistenz verarbeitet. Die Macarons werden 24 Stunden im Kühlhaus gereift, bevor sie ihre perfekte Textur erreichen.'
  },
  {
    id: 3,
    name: 'Schwarzwälder Kirschtorte',
    price: 45.00,
    rating: 5,
    shortDesc: 'Klassiker mit dunklen Kirschen',
    description: 'Unsere Schwarzwälder Kirschtorte ist ein Meisterwerk der Konditorkunst. Dunkle Schokolade, frische Sahne und herb-süße Kirschen bilden eine perfekte Einheit. Die Torte wird in unserer Manufaktur nach überliefertem Familienrezept hergestellt. Der Feinschliff: ein Hauch von Kirschwasser und echte Bourbonvanille. Die Torte reicht für 12 Personen.',
    image: '/images/3.jpg',
    isNew: false,
    detailedInfo: 'Die Schwarzwälder Kirschtorte von Novurem wird mit Kirschen aus dem Schwarzwald und echter Kakaomasse aus Ecuador hergestellt. Die Tortenböden werden über Nacht gereift und mit einer speziellen Kirsch-Sahne-Creme geschichtet. Jede Torte wird von Hand dekoriert und mit Schokoladenraspeln verfeinert.'
  },
  {
    id: 4,
    name: 'Kirsch-Pralinen-Auswahl',
    price: 34.90,
    rating: 4,
    shortDesc: 'Zwölf Pralinen mit Cherry-Brandy',
    description: 'Entdecken Sie unsere erlesene Kirsch-Pralinen-Auswahl. Zwölf handgefertigte Pralinen mit Kirschbrand und kandierten Kirschstückchen. Die Kombination aus dunkler Schokolade und fruchtigem Kirschherz ist ein Erlebnis. Jede Praline wird sorgfältig in unserer Werkstatt in Ettlingen gefertigt. Ideal als Geschenk oder für besondere Anlässe.',
    image: '/images/4.jpg',
    isNew: false,
    detailedInfo: 'Für die Kirsch-Pralinen verwenden wir nur Kirschen aus regionalem Anbau. Diese werden 48 Stunden in edlem Kirschbrand eingelegt und anschließend in zartschmelzende Kakaomasse getunkt. Unsere Chocolatiers überwachen jeden Schritt der Herstellung persönlich.'
  },
  {
    id: 5,
    name: 'Pistazien-Croissant',
    price: 18.90,
    rating: 5,
    shortDesc: 'Butter-Croissant mit Pistaziencreme',
    description: 'Unser Pistazien-Croissant ist die perfekte Verbindung von buttrigem Blätterteig und cremiger Pistazienfüllung. Jeden Morgen wird das Croissant frisch gebacken und mit hausgemachter Pistaziencreme gefüllt. Der köstliche Crunch von karamellisierten Pistazien rundet den Geschmack ab. Die Box enthält vier Croissants.',
    image: '/images/5.jpg',
    isNew: true,
    detailedInfo: 'Die Pistazien-Croissants werden nach traditionellem französischem Rezept zubereitet. Der Teig wird 72 Stunden lang geschichtet und mürbe gemacht. Unsere Pistaziencreme wird täglich frisch aus Sizilianischen Pistazien zubereitet und mit einem Hauch von Orangenblüte veredelt.'
  }
];

export default function Home() {
  const [targetDate] = useState(() => {
    const date = new Date();
    date.setDate(date.getDate() + 30);
    return date.getTime();
  });
  const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;
      if (distance < 0) {
        clearInterval(interval);
        return;
      }
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      setCountdown({ days, hours, minutes, seconds });
    }, 1000);
    return () => clearInterval(interval);
  }, [targetDate]);

  const decreaseFontSize = () => {
    const root = document.documentElement;
    const currentSize = window.getComputedStyle(root).fontSize;
    const currentSizeNum = parseFloat(currentSize);
    if (currentSizeNum > 12) {
      root.style.fontSize = (currentSizeNum - 1) + 'px';
    }
  };

  return (
    <div>
      <Helmet>
        <title>Novurem Patisserie - Feinste Confiserie in Ettlingen</title>
        <meta name="description" content="Entdecken Sie handgefertigte Pralinen, Macarons und Torten bei Novurem in Ettlingen. Höchste Qualität, traditionelle Rezepte, moderne Patisserie." />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Store",
            "name": "Novurem Patisserie",
            "description": "Boutique Konditorei für feine Pralinen, Macarons und Torten",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Heinzeallee 2/4",
              "postalCode": "19023",
              "addressLocality": "Ettlingen",
              "addressCountry": "DE"
            },
            "telephone": "+4977081869489",
            "email": "novurem@hotmail.com",
            "url": "https://novurem.com"
          })}
        </script>
      </Helmet>

      <section className="hero">
        <div className="container hero-inner">
          <span className="hero-tag">Boutique Konditorei</span>
          <h1 className="hero-title">Feinste Confiserie<br />mit Herz & Handwerk</h1>
          <p className="hero-text">
            Willkommen bei Novurem Patisserie. Wir verbinden traditionelle Handwerkskunst
            mit moderner Patisserie-Kunst. Jedes Stück wird mit Leidenschaft und besten
            Zutaten in unserer Manufaktur in Ettlingen kreiert.
          </p>
          <div className="hero-counter">
            <div className="counter-box">
              <span>{countdown.days}</span>
              <small>Tage</small>
            </div>
            <div className="counter-box">
              <span>{countdown.hours}</span>
              <small>Stunden</small>
            </div>
            <div className="counter-box">
              <span>{countdown.minutes}</span>
              <small>Minuten</small>
            </div>
            <div className="counter-box">
              <span>{countdown.seconds}</span>
              <small>Sekunden</small>
            </div>
          </div>
          <div className="hero-date">
            Bis zur Sommer-Edition {new Date(targetDate).toLocaleDateString('de-DE', { day: 'numeric', month: 'long', year: 'numeric' })}
          </div>
        </div>
      </section>

      <section className="advantages">
        <div className="container">
          <div className="products-header">
            <h2>Warum Novurem?</h2>
            <p>Handwerk, Qualität und Leidenschaft – das zeichnet unsere Produkte aus.</p>
          </div>
          <div className="advantages-grid">
            <div className="adv-item">
              <div className="adv-icon"><FaStar /></div>
              <h3 className="adv-title">Höchste Qualität</h3>
              <p>Nur erlesene Zutaten, keine künstlichen Zusätze.</p>
            </div>
            <div className="adv-item">
              <div className="adv-icon"><FaHeart /></div>
              <h3 className="adv-title">Mit Liebe gemacht</h3>
              <p>Jedes Stück wird von unseren Chocolatiers von Hand gefertigt.</p>
            </div>
            <div className="adv-item">
              <div className="adv-icon"><FaShoppingCart /></div>
              <h3 className="adv-title">Nachhaltig verpackt</h3>
              <p>Umweltfreundliche Verpackungen und regionale Lieferung.</p>
            </div>
            <div className="adv-item">
              <div className="adv-icon"><FaHome /></div>
              <h3 className="adv-title">Frische jeden Tag</h3>
              <p>Täglich neue Produkte direkt aus der Manufaktur in Ettlingen.</p>
            </div>
          </div>
          <div className="stats">
            <div className="stat-item">
              <div className="stat-number">1500+</div>
              <div className="stat-label">Zufriedene Kunden</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">15</div>
              <div className="stat-label">Jahre Erfahrung</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">25+</div>
              <div className="stat-label">Produkte im Sortiment</div>
            </div>
          </div>
          <div style={{ textAlign: 'center', marginTop: '30px' }}>
            <Link to="/about" className="btn btn-primary">Mehr über uns erfahren</Link>
          </div>
        </div>
      </section>

      <section className="about-section">
        <div className="container">
          <h2>Unsere Philosophie</h2>
          <div className="about-text">
            <p>
              Novurem Patisserie wurde mit dem Ziel gegründet, die Kunst der feinen Confiserie
              neu zu interpretieren. Unsere Manufaktur in Ettlingen verbindet traditionelle
              Rezepte aus der französischen und deutschen Konditorei-Tradition mit modernen
              Techniken. Das Ergebnis: Unvergleichliche Geschmackserlebnisse, die bei jedem
              Bissen begeistern.
            </p>
            <p>
              Wir beziehen unsere Rohstoffe von ausgewählten Partnern. Die Schokolade stammt
              aus nachhaltigem Anbau in Ecuador und Peru, die Pistazien aus Sizilien und die
              Vanille aus Madagaskar. Jede Zutat wird von unserem Meisterkonditor persönlich
              geprüft, bevor sie in unsere Produktion gelangt.
            </p>
            <p>
              Unsere Produkte werden in kleinen Chargen hergestellt, um höchste Frische und
              Qualität zu gewährleisten. Wir verzichten bewusst auf Konservierungsstoffe und
              künstliche Aromen. Stattdessen setzen wir auf natürliche Zutaten, viel Zeit und
              handwerkliches Können. Diese Philosophie spürt man in jedem einzelnen Produkt.
            </p>
            <p>
              Nachhaltigkeit ist für uns keine Option, sondern eine Verpflichtung. Unsere
              Verpackungen sind kompostierbar, wir unterstützen regionale Lieferanten und
              achten auf eine ressourcenschonende Produktion. Jedes Produkt, das unsere
              Manufaktur verlässt, trägt das Versprechen höchster Qualität und
              Verantwortungsbewusstsein.
            </p>
            <p>
              Die Novurem hat eine Erfolgsgeschichte, die auf Handwerkskunst und Innovation
              basiert. Seit der Gründung haben wir uns stetig weiterentwickelt und neue
              Kreationen erschaffen, die Kunden aus ganz Deutschland und darüber hinaus
              begeistern. Unsere Patisserie hat sich zu einer Adresse für Kenner und
              Genießer entwickelt.
            </p>
            <p>
              Wir sind überzeugt, dass Genuss kein Luxus, sondern ein tägliches Bedürfnis ist.
              Deshalb arbeiten wir unermüdlich daran, Ihnen mit unseren Produkten kleine
              Glücksmomente zu schenken. Ob zum Kaffee, zu besonderen Anlässen oder als
              Geschenk – mit Novurem wählen Sie das Beste vom Besten.
            </p>
          </div>
        </div>
      </section>

      <section className="products-section">
        <div className="container">
          <div className="products-header">
            <h2>Unsere Spezialitäten</h2>
            <p>Handgefertigt mit Liebe – in kleinen Mengen, in höchster Qualität.</p>
          </div>
          <div className="products-grid">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        </div>
      </section>

      <section className="products-section" style={{ paddingTop: '20px' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h2 className="products-header" style={{ fontSize: '26px' }}>Sind Sie bereit für ein Geschmackserlebnis?</h2>
          <p>Besuchen Sie unsere Manufaktur oder bestellen Sie direkt online – wir liefern deutschlandweit.</p>
          <div style={{ marginTop: '20px', display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/contact" className="btn btn-primary">Kontaktieren Sie uns</Link>
            <Link to="/cart" className="btn btn-secondary">Zum Warenkorb</Link>
          </div>
        </div>
      </section>
    </div>
  );
}